import PoweredByFindem from '../../../assets/images/svgs/findem-logo-black-small.svg?react';
import { LogoContainer, LogoImg, LogoText } from './PoweredByFindem.styled';

const LOGO_DIMENSIONS: Record<'sm' | 'md', number> = {
  sm: 10,
  md: 14,
};

type PoweredByFindemLogoProps = {
  $size?: 'sm' | 'md';
};

const PoweredByFindemLogo = ({ $size = 'md' }: PoweredByFindemLogoProps) => {
  const dimension = LOGO_DIMENSIONS[$size];

  return (
    <LogoContainer>
      <LogoImg><PoweredByFindem width={dimension} height={dimension} /></LogoImg>
      <LogoText $fontSize={`${dimension}px`}>Powered by Findem</LogoText>
    </LogoContainer>
  )
}

export default PoweredByFindemLogo;
